import { shape, string } from 'prop-types'

export const orderNowDocumentType = shape({
  documentId: string.isRequired,
  documentName: string.isRequired,
  documentFileName: string.isRequired,
  documentShortName: string.isRequired,
  documentType: string.isRequired,
  link: string.isRequired,
})
